import moment from "moment";

function reportName(prefix: string): string {
  const now = moment();
  return `${prefix}_${now.format("YYYYMMDD[_]HHmmss")}`;
}

export {
  reportName,
};
